export default __webpack_public_path__ + "static/img/MobileLoginImg.2f9196f.png";